import { createNlsMiddleware, documentapi, landingChange, locationChangeProcess, registry, userstate } from 'lcc-state';
import { publish } from 'pub-sub';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { DNode, WNodeFactory, WidgetProperties } from '@dojo/framework/core/interfaces';
// import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { Button } from '@dojo/widgets/button';
import { Video } from '@holmescorp/video';
import { convertToBoolean } from '@holmescorp/common';

import css from '../css/welcome-view.m.css';

export interface WelcomeViewProperties {}

const nls = createNlsMiddleware('ditabook');
const settingsNls = createNlsMiddleware('settings');

const factory = create({
	theme,
	nls,
	settingsNls,
	userstate,
	documentapi
}).properties<WelcomeViewProperties>();

export const WelcomeView = factory(({ middleware: { theme, nls, settingsNls, userstate, documentapi } }) => {
	const themeCss = theme.classes(css);

	const {
		messages: { welcome_title = '', welcome_view_a11y_description = '[landing] welcome_view_a11y_description' }
	} = nls();

	const {
		messages: { landing_page_video_only = 'false' }
	} = settingsNls();

	const videoOnly = convertToBoolean(landing_page_video_only);

	const skipButton = v('div', { key: 'skip-overview-video', xqa: 'skip-overview-video', classes: [themeCss.skip] }, [
		w(
			Button,
			{
				onClick: () => {
					if (videoOnly) {
						landingChange({ watched_video: true, complete: true });
						publish('explore/active');
					} else {
						landingChange({ watched_video: true });
						publish('site/landingpage');
						userstate.run(locationChangeProcess)({ location: '/' });
					}
				}
			},
			['Skip Video']
		)
	]);

	documentapi.setTitle(welcome_view_a11y_description);

	return v('div', { classes: [themeCss.welcome] }, [
		welcome_title ? v('h1', {}, [welcome_title]) : null,
		w(Video, { videonum: 1, fromWelcomePage: true, videoOnly }),
		skipButton
	]);
});

registry.define('LandingPageVideoWelcome', WelcomeView);
export default WelcomeView;
